/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react'
import { useView } from '../Contexts/ViewContext'
import { useSpeech } from '../Contexts/SpeechContext'
import { hooks } from 'botframework-webchat'
import { useRetorik } from '../Contexts/RetorikContext'
import { useUtilsStore, setListClosed } from '../Contexts/utilsStore'
import useCurrentOrLastPlayedActivity from '../../hooks/useCurrentOrLastPlayedActivity'
import ListTemplate from '../Templates/List'
import Attachments from '../Attachments/Attachments'

const { useSendBoxSpeechInterimsVisible } = hooks

const BotResponse = (): JSX.Element => {
  const { showHomeAttachments } = useView()
  const { speaking } = useSpeech()
  const activity = useCurrentOrLastPlayedActivity()
  const { displaySubtitles } = useRetorik()
  const listClosed = useUtilsStore((state) => state.listClosed)
  const [interimsVisible] = useSendBoxSpeechInterimsVisible()
  const [list, setList] = useState<boolean>()
  const [rowSpanVertical, setRowSpanVertical] = useState<string>(
    'rf-row-span-6 small-mobile:rf-row-span-7'
  )

  useEffect(() => {
    setRowSpanVertical(
      displaySubtitles && speaking
        ? 'rf-row-span-5 small-mobile:rf-row-span-6'
        : 'rf-row-span-6 small-mobile:rf-row-span-7'
    )
  }, [displaySubtitles, speaking])

  useEffect(() => {
    if (activity) {
      if (
        activity.attachmentLayout?.toLowerCase() === 'davilist' ||
        (activity.attachmentLayout !== 'carousel' &&
          activity.attachments &&
          activity.attachments.length > 1)
      ) {
        setList(true)
      } else {
        setList(false)
      }
    }
  }, [activity])

  return showHomeAttachments &&
    (showHomeAttachments as any).attachments?.length > 0 ? (
    <div
      id='retorik-botResponse'
      className={`rf-relative rf-w-full rf-h-full
        rf-col-start-1 large-vertical:rf-col-start-1 large:rf-col-start-5 rf-col-span-full
        rf-row-start-6 small-mobile:rf-row-start-5 large:rf-row-start-5 large-vertical:rf-row-start-7 ${rowSpanVertical} large:rf-row-span-full large-vertical:rf-row-span-4
        rf-overflow-y-scroll rf-scrollbar-thin
      `}
    >
      <div className='rf-w-full rf-h-full rf-flex rf-justify-center'>
        <Attachments activity={showHomeAttachments} />
      </div>
    </div>
  ) : activity?.type === 'message' ? (
    list ? (
      !interimsVisible && !listClosed ? (
        <ListTemplate
          activity={activity}
          onClose={(): void => setListClosed(true)}
        />
      ) : (
        <React.Fragment />
      )
    ) : (
      <div
        id='retorik-botResponse'
        className={`rf-relative rf-w-full rf-h-full
            rf-col-start-1 large-vertical:rf-col-start-1 large:rf-col-start-5 rf-col-span-full
            rf-row-start-6 small-mobile:rf-row-start-5 large:rf-row-start-5 large-vertical:rf-row-start-7 ${rowSpanVertical} large:rf-row-span-full large-vertical:rf-row-span-4
            rf-overflow-y-scroll rf-scrollbar-thin
          `}
      >
        <div className='rf-w-full rf-h-full rf-flex rf-justify-center'>
          {!!activity?.attachments?.length && (
            <Attachments activity={activity} />
          )}
        </div>
      </div>
    )
  ) : (
    <React.Fragment />
  )
}

export default BotResponse
